import physicalStores from '@views/physicalStores/physicalStores';

const physicalStoresRouter = [{
	path: 'physicalStores',
	name: 'physicalStores',
	// component: physicalStores,
  	component: resolve => require(['@views/physicalStores/physicalStores'],resolve),
	meta:{
		title: '店面搜索'
	}
}]

export default physicalStoresRouter;


// WEBPACK FOOTER //
// ./src/router/physicalStores/index.js